import { createStyles, rem } from '@mantine/core'

export default createStyles((theme) => {
  return {
    root: {
      backgroundColor: '#fff',
      borderRadius: 12,
      padding: 16,
      [theme.fn.largerThan('sm')]: {
        padding: 24,
      },
    },
    group: {
      display: 'flex',
      gap: 12,
      borderTop: `1px solid ${theme.colors.neutral[1]}`,
      paddingTop: 16,
      paddingBottom: 16,
      '&:first-child': {
        paddingTop: 0,
        borderTop: 0,
      },
      [theme.fn.smallerThan('sm')]: {
        flexDirection: 'column',
        gap: 12,
      },
    },
    inputRightSection: {
      fontSize: rem(14),
      lineHeight: rem(24),
      color: theme.colors.gray[4],
    },
    item: {
      [theme.fn.smallerThan('sm')]: {
        '&.gender': {
          width: '100%',
        },
        '&.age-item': {
          width: '100%',
        },
      },
      [theme.fn.largerThan('sm')]: {
        width: 220,
      },
    },
    longItem: {
      width: 'calc(100% - (230px * 3))',
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
      },
    },
    btn: {
      minWidth: 220,
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
      },
    },
  }
})
